import { useEffect } from "react";
import { X, Headset } from "lucide-react";
import { imgSrc, waLink, waNum } from "@/lib/api";
import WaIcon from "@/components/WaIcon";

export default function WhatsAppPicker({ open, onClose, contacts = [], message = "Halo Admin NAWADAH, saya ingin bertanya.", title = "Halo Kak, silakan pilih admin yang dapat membantu." }) {
  useEffect(() => {
    if (!open) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/65 p-4 backdrop-blur-sm" onMouseDown={onClose} data-testid="wa-picker">
      <div className="wa-brand-shell w-full max-w-md overflow-hidden rounded-2xl" role="dialog" aria-modal="true" aria-label="Pilih admin WhatsApp" onMouseDown={(event) => event.stopPropagation()}>
        <div className="wa-brand-header relative px-6 py-6 pr-14">
          <p className="text-lg font-semibold leading-relaxed">{title}</p>
          <button type="button" onClick={onClose} aria-label="Tutup pilihan WhatsApp" className="absolute right-4 top-4 rounded-full p-2 text-white/80 transition-colors hover:bg-white/15 hover:text-white">
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-2 p-4 sm:p-6">
          {contacts.map((contact, index) => (
            <a
              key={`${contact.number}-${index}`}
              href={waLink(message, waNum(contact.number))}
              target="_blank"
              rel="noreferrer"
              onClick={onClose}
              data-testid={`wa-picker-item-${index}`}
              className="wa-brand-row group flex items-center gap-4 rounded-xl border border-transparent p-3 transition-colors"
            >
              <span className="wa-brand-avatar relative flex h-16 w-16 shrink-0 items-center justify-center overflow-visible rounded-full">
                {contact.image ? (
                  <img src={imgSrc(contact.image)} alt={contact.label || `Admin Nawadah ${index + 1}`} className="h-full w-full rounded-full object-cover" />
                ) : (
                  <Headset className="h-8 w-8" />
                )}
                <span className="wa-brand-badge absolute -bottom-1 -right-1 flex h-7 w-7 items-center justify-center rounded-full shadow">
                  <WaIcon className="h-5 w-5" />
                </span>
              </span>
              <span className="min-w-0">
                <span className="wa-brand-eyebrow block text-xs font-semibold uppercase tracking-wider">Admin Account</span>
                <span className="wa-brand-name mt-0.5 block truncate text-lg font-extrabold">{contact.label || `NDH-Admin ${index + 1}`}</span>
              </span>
            </a>
          ))}
          {!contacts.length && <p className="px-3 py-8 text-center text-sm text-slate-400">Kontak WhatsApp belum tersedia.</p>}
        </div>

        <div className="wa-brand-footer px-6 py-4 text-center text-sm font-extrabold">NAWADAH <span>by NDH Official</span></div>
      </div>
    </div>
  );
}
